// extracted by mini-css-extract-plugin
export default {"root":"UserType_root__gqkBT","userTypeText":"UserType_userTypeText__8TYpL","icon":"UserType_icon__YIX1r"};